import client from './client';

export const getRiskSummary = () => client.get('/risk/summary');
export const getRiskEvents = (params) => client.get('/risk/events', { params });
export const getRiskEvent = (id) => client.get(`/risk/events/${id}`);
export const updateRiskEventStatus = (id, data) => client.put(`/risk/events/${id}/status`, data);
export const getRiskUserTimeline = (userId, params) => (
  client.get(`/risk/users/${userId}/timeline`, { params })
);
export const getRiskActivity = (params) => client.get('/risk/activity', { params });
export const getRiskRules = () => client.get('/risk/rules');
export const updateRiskRule = (code, data) => client.put(`/risk/rules/${code}`, data);
